"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stopMixpanelSessionReplay = exports.startMixpanelSessionReplay = exports.getSessionReplayProperties = void 0;
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
/**
 * These two methods will be exported in the Snowplow package so apps can manually start and stop Sessions.
 * Useful for apps with any CCP / Payment pages where we do not want a Session Replay to occur
 */
const startMixpanelSessionReplay = () => {
    mixpanel_browser_1.default.start_session_recording();
};
exports.startMixpanelSessionReplay = startMixpanelSessionReplay;
const stopMixpanelSessionReplay = () => {
    mixpanel_browser_1.default.stop_session_recording();
};
exports.stopMixpanelSessionReplay = stopMixpanelSessionReplay;
/**
 * Exports this method to be used as a helper in react hook
 */
const getSessionReplayProperties = () => {
    var _a;
    return (_a = mixpanel_browser_1.default.get_session_recording_properties()) !== null && _a !== void 0 ? _a : {};
};
exports.getSessionReplayProperties = getSessionReplayProperties;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9taXhwYW5lbC9zZXNzaW9uUmVwbGF5L2hlbHBlcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsd0VBQXdDO0FBRXhDOzs7R0FHRztBQUNILE1BQU0sMEJBQTBCLEdBQUcsR0FBUyxFQUFFO0lBQzFDLDBCQUFRLENBQUMsdUJBQXVCLEVBQUUsQ0FBQztBQUN2QyxDQUFDLENBQUM7QUFhbUMsZ0VBQTBCO0FBWC9ELE1BQU0seUJBQXlCLEdBQUcsR0FBUyxFQUFFO0lBQ3pDLDBCQUFRLENBQUMsc0JBQXNCLEVBQUUsQ0FBQztBQUN0QyxDQUFDLENBQUM7QUFTK0QsOERBQXlCO0FBUDFGOztHQUVHO0FBQ0gsTUFBTSwwQkFBMEIsR0FBRyxHQUEyQyxFQUFFOztJQUM1RSxPQUFPLE1BQUEsMEJBQVEsQ0FBQyxnQ0FBZ0MsRUFBRSxtQ0FBSSxFQUFFLENBQUM7QUFDN0QsQ0FBQyxDQUFDO0FBRU8sZ0VBQTBCIn0=


// WEBPACK FOOTER //
// ../../../../src/mixpanel/sessionReplay/helpers.ts